<template>
  <div class="product-add">

    <el-form size="small" ref="formData" :model="formData" label-width="200px">

      <el-form-item label="是否开启物流中心" prop="is_distribution">
        <el-switch v-model="formData.is_open_logistics"></el-switch>
      </el-form-item>
      <el-form-item label="是否开启总部备选仓：" prop="is_open_master_warehouse" >
        <el-radio-group v-model="formData.is_open_master_warehouse">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import LogisticsApi from '@/api/logistics.js';
export default {
  data() {
    return {
      /*form表单数据*/
      formData: {
        is_open_logistics: 'false',
        is_open_master_warehouse: null,
      }
    };
  },
  created() {
    this.getData();
  },

  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      LogisticsApi.settingDetail({}, true)
        .then(data => {
          self.formData = data.data.values;
          if (self.formData.is_open_logistics == 'true') {
            self.formData.is_open_logistics = true;
          }
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      LogisticsApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/logistics/setting/index.vue